"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const property_1 = require("@genesys/property");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const calculations_1 = require("@munters/calculations");
const initialState = {
    airstream1: initialProperties(),
    airstream2: initialProperties(),
    mixAirstream: property_1.PropertyValueSet.Empty,
    error: undefined
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "air-mixing-tool/SET-PROPERTIES-AIR1":
            return Object.assign(Object.assign({}, state), { airstream1: action.payload });
        case "air-mixing-tool/SET-PROPERTIES-AIR2":
            return Object.assign(Object.assign({}, state), { airstream2: action.payload });
        case "air-mixing-tool/CALCULATE-MIX":
            return Object.assign(Object.assign({}, state), { error: undefined, mixAirstream: calculateMix(state) });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function initialProperties() {
    return property_1.PropertyValueSet.fromString("temperature=20:Celsius;humidity=2:GramPerKilogram;pressure=101325:Pascal;flow=300:StandardCubicMeterPerHour");
}
function calculateMix(state) {
    const air1 = calculations_1.Physics.AirFlowState.create(property_1.PropertyValueSet.getAmount("temperature", state.airstream1), property_1.PropertyValueSet.getAmount("humidity", state.airstream1), property_1.PropertyValueSet.getAmount("pressure", state.airstream1), property_1.PropertyValueSet.getAmount("flow", state.airstream1));
    const air2 = calculations_1.Physics.AirFlowState.create(property_1.PropertyValueSet.getAmount("temperature", state.airstream2), property_1.PropertyValueSet.getAmount("humidity", state.airstream2), property_1.PropertyValueSet.getAmount("pressure", state.airstream2), property_1.PropertyValueSet.getAmount("flow", state.airstream2));
    const mix = calculations_1.Physics.AirCalculation.calculateAdiabaticMixingOfTwoAirstreams(air1, air2);
    const temperature = property_1.PropertyValue.fromAmount(mix.airOut.temperature);
    const humidity = property_1.PropertyValue.fromAmount(mix.airOut.humidity);
    const pressure = property_1.PropertyValue.fromAmount(mix.airOut.pressure);
    const flow = property_1.PropertyValue.fromAmount(mix.airOut.flow);
    const condensation = property_1.PropertyValue.fromInteger(mix.dehumidification ? 1 : 0);
    return property_1.PropertyValueSet.set("temperature", temperature, property_1.PropertyValueSet.set("humidity", humidity, property_1.PropertyValueSet.set("pressure", pressure, property_1.PropertyValueSet.set("flow", flow, property_1.PropertyValueSet.set("condensation", condensation, property_1.PropertyValueSet.Empty)))));
}
//# sourceMappingURL=reducer.js.map